<template>
  <div :class="['mx-auto']" style="max-width: 1490px">
    <v-row v-if="errored">
      <msgErr
        :mensaje="`Se produjo un Error  Procesando la Consulta, 
            detalle => ${erroredData}`"
      >
      </msgErr>
    </v-row>
    <v-row no-gutters v-else>
      <v-col
        cols="12"
        xs="2"
        md="3"
        class="menu"
        v-if="$vuetify.breakpoint.mdAndUp"
      >
        <v-card class="mt-2 mx-auto v-cardgrid" max-width="450" outlined >
          <v-toolbar
            class="subtitle-1 font-weight-bold rounded-0"
            flat
            color="primary"
            dark
            dense
          >
            <v-select
              :disabled="numitems === 0"
              v-if="categorias"
              @change="goCat(selectidcat)"
              :items="categorias"
              item-text="Nombre"
              item-value="Categoria"
              :label="nombreCat(codCat)"
              v-model="selectidcat"
              return-object
              single-line
              dense
              color="white"
              solo
              background-color="accent"
              class="mt-0"
              hide-details
              :menu-props="{ top: false, offsetY: true }"
            ></v-select>
          </v-toolbar>
          <filtroDisponible />
          <listaPromo />
          <ChangeDisponible v-if="false"/>
          <v-expansion-panels v-model="panel" multiple accordion>
            <v-expansion-panel>
              <v-expansion-panel-header class="body-1 my-n2">
                SUB CATEGORIAS
                <template v-slot:actions>
                  <v-icon> {{ null }}</v-icon>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <listaScat />
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel>
              <v-expansion-panel-header class="body-1 my-n2">
                MARCAS
                <template v-slot:actions>
                  <MarcaContent />
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <MarcasFiltro
                  :nitems="numitems"
                  :tammarca="filterconsolidado.length"
                  :tamsubcat="filterscat.length"
                  :filterdata="filter"
                />
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel v-if="formatosItem.length !== 0">
              <v-expansion-panel-header class="body-1 my-n2">
                FORMATO
                <template v-slot:actions>
                  <FormatoContent />
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <FiltroFormato :formatosItem="formatosItem" />
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel v-if="calidadItem.length !== 0">
              <v-expansion-panel-header class="body-1 my-n2">
                CALIDAD
                <template v-slot:actions>
                  <CalidadContent />
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <FiltroCalidad :calidadItem="calidadItem" />
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        v-if="!$vuetify.breakpoint.mdAndUp"
        class="menu"
        :style="{ zIndex: 1 }"
      >
        <FiltroCatMobile />
      </v-col>
  
      <v-col cols="12" xs="10" md="9" :style="{ zIndex: 0 }" class="menu">
        <keep-alive>
          <gridnew />
        </keep-alive>

        <msgQueryGrid
          :mensaje="`Sin resultados para esta busqueda`"
          :tamFitro="filterconsolidado.length"
        >
        </msgQueryGrid>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
  import btnSelPromo from "../components/botonselpromo";
  import msgErr from "../components/MensajeError";
  import msgQueryGrid from "../components/GridQueryMsg";
  import MarcasFiltro from "../components/ListaMarcas";
  import txtBuscar from "../components/BuscarScat";
  import listaScat from "../components/ListaSubCat";
  import listaPromo from "../components/ListaPromo";
  import listaRep from "../components/ListaMaqRep";
  import gridnew from "../components/GridProductos";
  import TituloCat from "../components/TituloCat";
  import {
    FiltroFormato,
    FiltroCalidad,
    CalidadContent,
    FormatoContent,
    MarcaContent,
    FiltroCatMobile,
  } from "./Filtros";
  import { ChangeDisponible } from "./ChangeDisponible";
  import { Paleta, Paquete } from "./Icons";
  import { InfoExistencia } from "./InfoExistencia";
  import filtroDisponible from "../components/FiltroDisponible";

  export default {
    name: "FiltroCat",
    data() {
      return {
        panel: [0],
        active: false,
        preload: [0],
        loading: false,
        loading2: false,
        search: "",
        selected: [],
        subcat: true,
        page: 1,
        dialog: false,
        link: null,
        uri: null,
        selectidcat: "",
        controller: new AbortController(),
      };
    },
    destroyed() {
      this.controller.abort();
    },
    created() {
      const { div, dep, cat, scat } = this.$route.params;
      this.set_subcategoria(scat);
      this.set_varCategorias([div, dep, cat]);
      this.consolidadoSCategoria({ signal: this.controller.signal });
      this.$vuetify.goTo(0);
    },
    components: {
      btnSelPromo,
      ChangeDisponible,
      msgErr,
      msgQueryGrid,
      MarcasFiltro,
      listaPromo,
      gridnew,
      FiltroFormato,
      FiltroCalidad,
      CalidadContent,
      FormatoContent,
      MarcaContent,
      FiltroCatMobile,
      txtBuscar,
      listaScat,
      TituloCat,
      listaRep,
      Paleta,
      Paquete,
      InfoExistencia,
      filtroDisponible
    },
    watch: {
      selected() {
        this.search = "";
      },
      $route(to, from) {
        this.$vuetify.goTo(0);
        this.CLR_DATOS_ART();
        this.CLR_BUSCARSCAT();
        this.CLR_BUSCARMARCA();
        this.CLR_BUSCARMARCAtt();
        this.CLR_BUSCARPROMO();
        this.CLR_ERROR_AXIOS();
        this.subcat = false;
        this.active = false;
        this.page = 1;
        this.loading2 = false;
      },
      deep: true,
      immediate: true,
    },
    computed: {
      ...mapGetters(["filterconsolidado", "filterscat", "filtermarca"]),
      ...mapState([
        "division",
        "departam",
        "categoria",
        "dataUser",
        "marcaidsel",
        "SubCategorias",
        "ttMarcas",
        "consolidadoSubcat",
        "loadingSubCat",
        "ttArticuloAll",
        "filter",
        "errored",
        "erroredData",
        "selectScat",
        "dataUser",
        "Cliente",
        "simboloMoneda",
        "tipoMoneda",
        "mnuCategorias",
        "imgPeque",
        "imgMarcas",
        "IndVerPreciosExt",
        "IndVerPrecios",
        "maestro",
      ]),
      formatosItem: function () {
        let uniqueArray = [];

        if (this.ttArticuloAll) {
          uniqueArray = [
            ...new Set(
              this.ttArticuloAll
                .filter(
                  (x) =>
                    x.SubCategoria === this.filter.codscat && x.Formato !== ""
                )
                .map((x) => ({
                  Formato: x.Formato,
                }))
            ),
          ];

          return uniqueArray.sort(
            (a, b) => this.formatNumero(b.Formato) - this.formatNumero(a.Formato)
          );
        }
      },
      calidadItem: function () {
        let uniqueArray = [];

        if (this.ttArticuloAll) {
          uniqueArray = [
            ...new Set(
              this.ttArticuloAll
                .filter(
                  (x) => x.SubCategoria === this.filter.codscat && x.Calidad !== ""
                )
                .map((x) => ({
                  Calidad: x.Calidad,
                }))
            ),
          ];
          return uniqueArray.sort((a, b) => a.Calidad - b.Calidad);
        }
      },
      categorias() {
        if (Object.entries(this.maestro).length !== 0) {
          return this.maestro.ttCategoria;
        }
      },
      color() {
        return ["#0D47A1", "#1E88E5", "#64B5F6"][
          Math.floor(this.filterconsolidado.length / 40)
        ];
      },
      marcasNew() {
        var nb = [];
        if (this.ttMarcas) {
          if (this.filterscat.length != 0) {
            nb = this.filterscat.filter(
              (v, i, a) => a.findIndex((t) => t.Marca === v.Marca) === i
            );
          } else
            nb = this.ttMarcas.filter(
              (v, i, a) => a.findIndex((t) => t.Marca === v.Marca) === i
            );
        }
        return nb;
      },
      numitems() {
        if (this.filterconsolidado) return this.filterconsolidado.length;
      },
      ttScatItem: {
        get: function () {
          let arr = [];
          if (this.SubCategorias) {
            arr = this.SubCategorias.filter((x) => x.SubCategoria != 0).map(
              (x) => x.SubCategoria
            );
            return arr;
          }
        },
      },
      nombreSCat: function () {
        return function (id, idscat) {
          if (this.SubCategorias) {
            var nb = this.SubCategorias.filter(
              (x) => x.Categoria === id && x.SubCategoria === idscat
            ).map((x) => x.Nombre);
            return nb.toString();
          }
        };
      },
      nombreCat: function () {
        return function (id) {
          if (this.SubCategorias) {
            var nb = this.SubCategorias.filter(
              (x) => x.Categoria === id && x.SubCategoria === 0
            ).map((x) => x.Nombre);
            return nb.toString();
          }
        };
      },
      nombreMarca: function () {
        return function (id) {
          if (this.marcasNew)
            return this.marcasNew
              .filter((x) => x.Marca === id)
              .map((x) =>
                this.filterscat.length != 0 ? x.NombreMarca : x.Nombre
              )
              .toString();
        };
      },
      removeItemSel: function () {
        return function (id) {
          return id;
        };
      },
      checkMarca: function () {
        return function (id) {
          this.GET_BUSCARMARCA(id);
          return this.marcaidsel;
        };
      },
      codCat: {
        get: function () {
          if (this.$route.params) return parseInt(this.$route.params.cat);
        },
      },
    },
    methods: {
      ...mapActions([
        "consolidadoSCategoria",
        "cargarDatosMarcaCat",
        "get_SubCategorias",
      ]),
      ...mapMutations([
        "GET_BUSCARCAT",
        "set_AdPromoF",
        "set_subcategoria",
        "SET_DATOS_SUBCAT",
        "SET_DATOS_SUBCAT_MARCA",
        "SET_DATOS_SUBCAT_ARRAY",
        "CLR_DATOS_SUBCAT",
        "SET_DATOS_SUBCAT_ALL",
        "GET_BUSCAR",
        "GET_BUSCARMARCA",
        "GET_BUSCARSCAT",
        "CLR_BUSCARSCAT",
        "CLR_BUSCARMARCAtt",
        "CLR_BUSCARMARCA",
        "CLR_BUSCARQUERY",
        "CLR_DATOS_ART",
        "CLR_PRECIO",
        "SELECTSCAT",
        "GET_PRECIO1",
        "GET_PRECIOALL",
        "set_varCategorias",
        "CLR_BUSCARPROMO",
        "CLR_ERROR_AXIOS",
        "CLR_BUSCAREPUESTO",
      ]),
      formatNumero(formato) {
        const [ancho, alto] = formato.toUpperCase().split("X").map(Number);
        return ancho * alto;
      },
      statusDlg(st) {
        if (st === true) this.dialog = false;
      },
      goCat(ccat) {
        if (this.codCat != ccat.Categoria) {
          this.CLR_DATOS_SUBCAT();
          this.GET_BUSCARCAT(ccat.Categoria);
          this.CLR_BUSCARPROMO();
          this.CLR_BUSCARSCAT();
          this.CLR_BUSCARMARCA();
          this.CLR_ERROR_AXIOS();
          this.CLR_BUSCAREPUESTO();
          this.set_AdPromoF();
          window.scrollTo(0, 0);
          this.selectidcat = ccat.Categoria;
          this.set_varCategorias([10, ccat.Categoria, this.selectidcat]);
          this.consolidadoSCategoria();
          return this.$router.push(
            `/subcategoria/${10}/${ccat.Categoria}/${this.selectidcat}`
          );
        }
      },
      articuloRoute(codart) {
        return this.$router.push("/articulo/" + codart);
      },
      itemscat(valor) {
        this.GET_BUSCARSCAT(valor);
      },
      addSubcat(scat) {
        this.catfilter.push(scat);
        return this.catfilter;
      },
    },
  };
</script>

<style scoped>
  .v-cardgrid {
    background-color: #ffffff !important;
    border: 1px solid #b05954 !important;
    transition: opacity 0.4s ease-in-out;
  }
  .img_scat {
    width: 60%;
    max-width: 60%;
    display: block;
    margin-left: auto;
    margin-right: auto;
    opacity: 1;
    cursor: pointer;
  }

  .v-cardgrid:not(.on-hover) {
    opacity: 1;
  }

  .menu {
    height: 100%;
    position: sticky;
    top: 90px;
  }
</style>
